// ページが読み込まれた後に実行される処理
window.addEventListener('DOMContentLoaded', function() {
  // 初回実行
  handleScreenSizeChange();

  // ウィンドウのサイズ変更時に実行される処理
  window.addEventListener('resize', handleScreenSizeChange);

  // ウィンドウのサイズ変更時に呼び出される関数
  function handleScreenSizeChange() {
    // 端末の幅を取得
    var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    // 幅が768px以下の場合のみ処理を実行
    if (screenWidth <= 768) {
      // 空白部分のテキストを取得
      var element = document.querySelector('#shopify-section-template--21703328497939__ba72c90b-0c26-4c3c-915b-8682ee92c758 .rich-text__text:nth-of-type(2)');
      var text = element.innerHTML;

      // 空白を改行に置換して表示
      var newText = text.replace(/　+/g, '<br>');
      element.innerHTML = newText;
    }
  }
});